import { createContext } from 'react';
const AppDataContext = createContext({ today: '' });
export default AppDataContext;
